{
  "blocks": [
    {
      "id": "tip-egg-quality",
      "kind": "tip",
      "tags": ["her", "optimization", "egg-freezing", "pre-cycle"],
      "title": "Her egg quality optimization",
      "subtitle": "Supporting the eggs you already have",
      "icon": "♀",
      "body": {
        "advice": "Key supplements: CoQ10 (400-600mg/day), Omega-3s (1-2g EPA/DHA), methylfolate (800-1000mcg), Vitamin D (2000-4000 IU). Start 3 months before your planned cycle.",
        "rationale": "You can't change your eggs' DNA - but you can change the environment they mature in. The last 3 months of egg development are most sensitive to nutritional and lifestyle factors.",
        "category": "supplement"
      },
      "sources": [
        {
          "title": "Nutritional approaches to egg quality improvement",
          "journal": "Fertility and Sterility",
          "year": 2021,
          "evidenceLevel": "cohort"
        }
      ]
    }
  ],
  "relationships": [],
  "localeVariants": []
}
